var returnNumber = function returnNumber(string) {
    return string.replace(/\D/g, "");
}

// Setup checkboxes and form elements behavior

var $checkboxes = document.getElementsByName('qr-code-type'),
    $inputContent = document.getElementById('qr-code-content');
    $inputGroupWrapper = $inputContent.closest('.form-group'),
    $inputLabel = $inputGroupWrapper.getElementsByTagName('label')[0],
    $form = document.querySelector('.js-qr-code-form'),
    $formButton = $form.querySelector('.js-results-button'),
    $btnDownloadImage = document.querySelector('.js-btn-download-qrcode'),
    $formSubscribe = document.querySelector('.js-form-subscribe'),
    $alertDownloadSuccess = document.querySelector('.js-alert-download-success'),
    rdEndpoint = 'https://www.rdstation.com.br/api/1.3/conversions',
    $fieldContent = document.getElementById('qr-code-content'),
    $btnRegenerate = document.querySelector('.js-regenerate'),
    $hiddenFieldWrapper = document.querySelector('.js-phone-message'),
    $hiddenField = document.getElementById('qr-code-content-message'),
    waEndPoint = 'https://wa.me/',
    delayAnimation = 200,
    phoneCountryCode = {
        'AR': 54,
        'BR': 55,
        'MX': 52
    };

    switch (country) {
        case 'pt_br':
            countryRegex = /[-+]?[0-9]*[.,]?[0-9]+/;
            break;

         case 'es_mx':
            countryRegex = /^(\+?52)?(1|01)?\d{10,11}$/;
            break;

        default:
            countryRegex = /[-+]?[0-9]*[.,]?[0-9]+/;
            break;
    }

    validationPatterns = {
        'phone': countryRegex,
        'url': /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/
    }


function readyForGenerate() {
    $hiddenField.classList.add('ignored');

    $formButton.removeAttribute('disabled')

    $checkboxes.forEach(function(element) {
        element.addEventListener('change', function(e) {

            if (window.innerWidth <= 600) {
                handleScroll($form);
            }

            Object.entries(inputs).forEach(el => {
                if (el[0] == element.value) {
                    $inputLabel.innerText = el[1].label;
                    $inputContent.setAttribute('placeholder', el[1].placeholder);

                    switch (element.value) {
                        case 'website':
                            $inputContent.setAttribute('type', 'url');
                            handleExtraField();
                            break;

                        case 'phone':
                            $inputContent.setAttribute('type', 'tel');
                            $hiddenFieldWrapper.classList.remove('hide');
                            $hiddenFieldWrapper.removeAttribute('aria-hidden');
                            $hiddenField.classList.remove('ignored');
                            break;

                        default:
                            $inputContent.setAttribute('type', 'text');
                            handleExtraField();
                            break;
                    }
                }
            });
        })
    });


    var validate = new Bouncer('.js-qr-code-form', {
        disableSubmit: true,
        patterns: {
            tel: validationPatterns.phone,
            url: validationPatterns.url,
        },
        messages: {
            missingValue: {
                url: validationErrors.required,
                default: validationErrors.required
            },
            patternMismatch: {
                url: validationErrors.url,
                tel: validationErrors.tel
            }
        },
    })

    $form.addEventListener('submit', function(e){

        var isValid = validate.validate($fieldContent),
            data = serializeArray($form);

        if (!isValid) {
            handleGenerate(data)
        }
    });

    function handleGenerate(data) {

        if (data[1].value == 'phone') {
            console.log(data);

            var currentCountryCode = phoneCountryCode[data[0].value];
            var celNumber = '+' + currentCountryCode + returnNumber(data[2].value),
                text = data[3] ? '?text=' + encodeURI(data[3].value) : '';

            data[2].value = waEndPoint + celNumber + text;

        }

        var canvas = document.querySelector('canvas'),
            qr = new QRious({
                element: canvas,
                backgroundAlpha: 0,
                foreground: '#2d2938',
                value: data[2].value,
                size: 3000,
            });

        qr.toDataURL();
        qr.toDataURL('image/png');

        handleSuccess(true);
        handleDownload(canvas, 'QRCode-Generated-' + data[1].value);
        amplitude_log_event('tools_qrcode_generated', {
            'type': data[1].value
        });

        $btnRegenerate.addEventListener('click', e => {
            e.preventDefault();

            $form.reset();
            handleSuccess(false);
            handleExtraField();
        });
    };

    function handleScroll(to) {
        window.scrollTo({
            top: to ? to.getBoundingClientRect().top + document.documentElement.scrollTop - 30 : 0,
            behavior: 'smooth'
        });
    }

    function handleExtraField() {
        $hiddenFieldWrapper.classList.add('hide');
        $hiddenFieldWrapper.setAttribute('aria-hidden', true);
        $hiddenField.classList.add('ignored');
    }

    function handleSuccess(forward) {
        // Animating item
        var $result = document.querySelector('.js-result-wrapper'),
            $title = document.querySelector('.js-hero-title'),
            $subTitle = document.querySelector('.js-hero-subtitle');

        handleScroll();

        // Forward animation
        if (forward) {
            $form.classList.add('slide-up-out');
            $form.classList.remove('slide-up');

            $title.classList.remove('slide-up');
            $subTitle.classList.remove('slide-up');

            setTimeout(function(){
                $result.classList.add('slide-up');
                $result.classList.remove('hide');
                $form.classList.add('hide');
                $form.classList.remove('slide-up-out');

                $title.classList.add('slide-up-out');
                $subTitle.classList.add('slide-up-out');
            }, delayAnimation);

            setTimeout(() => {
                $subTitle.classList.add('hide');
                $subTitle.classList.remove('slide-up-out');

                $title.classList.add('slide-up', 'text-center-xs');
                $title.classList.remove('slide-up-out');

                $title.innerText = pageTitleSuccess;
            }, delayAnimation * 2);
            return;
        }

        // Backward animation
        $title.classList.remove('slide-up');
        $title.classList.add('slide-up-out');

        setTimeout(() => {
            $title.innerHTML = pageTitle;
            $title.classList.remove('slide-up-out');
            $title.classList.add('slide-up');

            $subTitle.classList.remove('hide');
            $subTitle.classList.add('slide-up');

            $result.classList.add('slide-up-out');
            $result.classList.remove('slide-up');

        }, delayAnimation);

        setTimeout(function(){
            $result.classList.add('hide');
            $result.classList.remove('slide-up-out');

            $form.classList.add('slide-up');
            $form.classList.remove('hide', 'slide-up-out');

            $alertDownloadSuccess.classList.replace('slide-up', 'hide');

        }, delayAnimation * 2);
    };

    async function postData(url, data, header = 'application/x-www-form-urlencoded') {
        var response = await fetch(url, {
            method: 'POST',
            headers: {'Content-Type': header },
            body: data
        });

        return response.json();
    };

    function handleDownload(canvas, fileName) {
        var image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

        $btnDownloadImage.setAttribute("href", image);
        $btnDownloadImage.setAttribute("download", fileName + ".png");
    };

    function handleRdstationPush(email) {
        var rdBody = {
            token_rdstation: '4ac98d510af23fd1b39770575544b8e0',
            url: window.location.href,
            identificador: 'gerador-qrcode-ext-cm',
            traffic_source: '00000000.0000000000.00.00.utmcsr=direct|utmccn=(not set)|utmcmd=(not set)|utmcct=(not set)|utmctr=(not set)',
            email: email,
            legal_bases: [{
                category: 'data_processing',
                type: 'legitimate_interest'
            },
            {
                category: 'communications',
                status: 'granted',
                type: 'legitimate_interest'
            }]
        }

        return rdBody;
    }


    $btnDownloadImage.addEventListener('click', e => {

        $alertDownloadSuccess.classList.add('slide-up')
        $alertDownloadSuccess.classList.remove('hide')

        if(!$.cookie('subscribed_at_qrcode')) {
            $('#modal-subscribe').modal('show');
            amplitude_log_event('tools_qrcode_downloaded_and_subscribed');
            return;
        }

        amplitude_log_event('tools_qrcode_downloaded');
    });

    $formSubscribe.addEventListener('submit', e => {
        e.preventDefault();

        var data = new FormData($formSubscribe), // Backend needs to recieve a form
            formData = serializeArray($formSubscribe); // hubspot needs to recieve a json

        fetch(endPoint, {
            method: 'POST',
            body: data
        })
        .then(r => r.json())
        .then(data => {
            hubspotIntegration(formData, null, function() {
                hubspotCustomEvents('tools_[qrcode]');
                amplitude_log_event('tools_qrcode_subscribed');

                $.cookie('subscribed_at_qrcode', true, { expires: 30, path: '/' });
                $('#modal-subscribe').modal('hide');

                if (country === 'pt_br') {
                    var rdFormatedData = handleRdstationPush(formData[2].value)

                    postData(rdEndpoint, JSON.stringify(rdFormatedData), 'application/json')
                        .then(rdFormatedData => {
                            amplitude_log_event('tools_qrcode_subscribed_to_rd');
                        });
                }
            });
        });
    });
}

function checkIfReady() {
    if (typeof Bouncer != 'undefined' && typeof toolsSubscribe != 'undefined') {
        readyForGenerate();
    } else {
        setTimeout(checkIfReady, 1000);
    }
}

checkIfReady();